export default {
  setSearchIndexes (state, searchIndexes) {
    state.searchIndexes = searchIndexes;
  },

  setActiveSearchIndex (state, activeSearchIndex) {
    state.activeSearchIndex = activeSearchIndex;
  },
};
